/**
 * @copyright (C) 2025, rsupport. All rights reserved
 *
 * @license
 * This software and/or source code may be used, copied and/or disseminated only
 * with the written permission of rsupport, or in accordance with the terms
 * and conditions stipulated in the agreement/contract under which the software
 * and/or source code has been supplied by rsupport or its affiliates.
 * Unauthorized use, copying, or dissemination of this file, via any medium, is
 * strictly prohibited, and will constitute an infringement of copyright.
 *
 * @author
 * Charyung Kim (crkim@rsupport.com)
 *
 * @description
 *
 * @created at Wed Feb 19 2025
 **/

import styled from "@emotion/styled";

import { Row } from "@/frameworks/designStuff/components";

/* Desktop */

export const AvatarWrap = styled(Row)`
	width: 60px;
	height: 60px;
`;

export const ToolButtonWrap = styled.button`
	height: 40px;
	cursor: pointer;
	& svg {
		margin: 8px;
	}
	&:hover,
	&:active {
		background-color: #ffffff14;
		border-radius: 50%;
	}
`;

export const ViewerHeaderWrap = styled(Row)`
	z-index: 1;
	position: absolute;
	top: 0;
	left: 0;
	width: 100%;
	height: 60px;
	background-color: ${({ theme }) => theme.colors.neutral_blue_70_100};
	box-shadow:
		0px 0px 4px 0px rgba(0, 0, 0, 0.04),
		0px 4px 8px 0px rgba(0, 0, 0, 0.12);
`;

/* Mobile */

export const MobileCloseWrap = styled.div`
	display: flex;
	position: absolute;
	right: 12px;
`;

export const MobileViewerFooterWrap = styled.div`
	position: absolute;
	bottom: 12px;
	background-color: ${({ theme }) => theme.colors.neutral_80_100};
	border: solid 1px  ${({ theme }) => theme.colors.neutral_70_100};
	box-shadow: 0px 1px 4px 0px #00000080;
	border-radius: 20px;
	padding: 4px 12px 4px 12px;
	display: flex;
	gap: 8px;
	transform: translateX(-50%);
    left: 50%;
	z-index: 2;
}
`;
